import React, { useState, useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { useAddUpdateGlobalListMutation, useGetGlobalDropdownQuery } from "../ActivityLogs/AuditLogAPIS";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import AddItemPlus from "../UniversalComponents/AddItemPlus";
import InternalNavigation from "../Customize/InternalNavigation";
import { ReactComponent as EditIcon } from "../../assets/images/icons/EditPencil.svg";
import ChoiceField from "../GlobalFeature/Table/ChoiceField";

const GlobalListsDropdownTable = () => {
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [shadowColor, setShadowColor] = useState("");
  const [inputVisible, setInputVisible] = useState(false);
  const [allowMultiple, setAllowMultiple] = useState(false);
  const [isEmptyOption, setIsEmptyOption] = useState(false);
  const [EditFieldData, setEditFieldData] = useState(null);
  const [dropDownId, setDropdownId] = useState(null);
  const [isAddChoice, setIsAddChoice] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  const [extraFieldData, setExtraFieldData] = useState({
    field_name: "",
    field_label: "",
    field_options: [],
    field_type: "",
    field_description: "",
  });

  const [saveGlobalDropdown, { data: saveData, isLoading, isSuccess, isError, error }] =
    useAddUpdateGlobalListMutation();

  console.log(saveGlobalDropdown, "saveGlobalDropdown");

  const {
    data: globalDropdownData,
    isLoading: globalDropdownLoading,
    isFetching: globalDropdownFetching,
    isError: globalDropdownError,
    error: globalDropdownErrorData,
    isSuccess: globalDropdownSuccess,
    refetch: getGlobalDropdownRefetch,
  } = useGetGlobalDropdownQuery(undefined, {
    // skip: false,
    // refetchOnFocus: false,
    // refetchOnReconnect: false,
    // refetchOnMount: false,
    // refetchOnMountOrArgChange: false,
  });

  const handleCkeckDuplicateList = (listName) => {
    const isDuplicateName = globalDropdownData?.data?.some(
      (item) => item.name.toLowerCase() === listName.toLowerCase() && item.id !== dropDownId
    );
    if (isDuplicateName) {
      setIsDuplicate("This list name already exists.");
    } else {
      setIsDuplicate("");
    }
  };

  const tableHeader = [
    { accessor_key: "name", label: "Name" },
    { accessor_key: "is_global", label: "Scope" },
    { accessor_key: "description", label: "Description" },
    { accessor_key: "created_by", label: "Created By" },
  ];

  const handleEditClick = (item) => {
    setIsEdit(true);
    setDropdownId(item?.id);
    setExtraFieldData((prev) => ({
      ...prev,
      field_name: item?.name || "",
      field_label: item?.label || "",
      field_description: item?.description || "",
      field_options:
        item?.values?.map((val) => ({
          value: val.label,
          color_code: val.color_code || "",
          id: val.id,
        })) || [],
    }));
    setEditFieldData({
      field_options: item?.values?.map((val) => ({
        value: val.label,
        color_code: val.color_code || "",
        id: val.id,
      })),
    });
  };

  const handleAddClick = () => {
    setIsAddChoice(true);
    setDropdownId(null);
    setExtraFieldData({
      field_name: "",
      field_label: "",
      field_options: [],
      field_type: "",
      field_description: "",
    });
  };

  const handleFieldChange = (field, e) => {
    const newValue = e.target.value;
    setExtraFieldData((prevState) => ({
      ...prevState,
      [field]: newValue,
      ...(field === "field_label" && { field_name: newValue }),
    }));
  };

  const handleSave = () => {
    const isColorEnabled = extraFieldData.field_options.some((opt) => opt.color_code && opt.color_code.trim() !== "");

    const payload = {
      name: extraFieldData.field_name,
      label: extraFieldData.field_label,
      description: extraFieldData.field_description,
      is_color_enabled: isColorEnabled,
      values: extraFieldData.field_options.map((opt) => ({
        label: opt.value,
        color: opt.color_code || null,
      })),
    };

    if (dropDownId) {
      payload.id = dropDownId;
    }

    console.log("Payload sending to API:", payload);
    saveGlobalDropdown(payload);
  };

  const handleCancelButton = () => {
    setIsEdit(false);
    setIsAddChoice(false);
  };

  const removeChoiceApi = (fieldId, optionId) => {
    console.log(`Removing option ${optionId} from field ${fieldId}`);
  };

  const handleFieldOptionUpdate = (fieldId, optionId, newValue) => {
    console.log(`Updating option ${optionId} in field ${fieldId} to new value: ${newValue}`);
  };

  const handleFieldOptionAdd = (fieldId, newOptionValue) => {
    console.log(`Adding new option to field ${fieldId} with value: ${newOptionValue}`);
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    // Success handling
    if (isSuccess) {
      dispatch(
        pushAlert({
          message: saveData?.message || "List saved successfully",
          type: saveData?.success ? "success" : "danger",
          visible: true,
        })
      );

      if (saveData?.success) {
        getGlobalDropdownRefetch();

        setIsEdit(false);
        setIsAddChoice(false);
        setDropdownId(null);
        setExtraFieldData({
          field_name: "",
          field_label: "",
          field_options: [],
          field_type: "",
          field_description: "",
        });
        setEditFieldData(null);
        setInputValue("");
        setShadowColor("");
        setAllowMultiple(false);
        setIsEmptyOption(false);
      }
    }

    if (isError) {
      dispatch(
        pushAlert({
          message: error?.data?.message || "Failed to save list",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isLoading, isSuccess, isError]);

  return (
    <div className="p-3 w-full h-full">
      <p className="">
        <span className="text-md text-gray-500 italic">
          A central place to create and manage the options that appear in your dropdown fields. Update a choice once,
          and it stays consistent everywhere it’s used. This helps keep your dropdown lists clean, organized, and easy
          for everyone to work with.
        </span>
      </p>
      <div className="flex h-full gap-2">
        <div className="min-w-0 grow flex h-full">
          <ReactTableComponent
            tablename={
              <div className="text-base font-medium ">
                {/* <InternalNavigation
                  items={[
                    { label: "Modules & Templates", value: "modules", component: "modules" },
                    { label: "Manage Dropdowns", value: "global-list", component: "global-list" },
                    { label: "Manage Tags", value: "tag-list", component: "tag-list" },
                  ]}
                  subTabValue={"global-list"}
                /> */}
                Manage Dropdowns
              </div>
            }
            headers={tableHeader}
            body={globalDropdownData?.data || []}
            actionColumn={(item) => (
              <div className="text-primary-60">
                <button onClick={() => handleEditClick(item)}>
                  <EditIcon className="fill-current" />
                </button>
              </div>
            )}
            actionField={
              <span onClick={() => handleAddClick()}>
                <AddItemPlus isActive={isAddChoice} isHovered={isHovered} />
              </span>
            }
          />
        </div>

        {(isEdit || isAddChoice) && (
          <div className="w-1/3 py-3 border border-[#DFE2E5] rounded h-full flex flex-col">
            <div className="flex justify-between items-center mb-4 border-b h-fit px-3 pb-2">
              <h4 className="text-sm font-medium">{dropDownId ? "Edit" : "Add"} List</h4>
              <button onClick={handleCancelButton}>
                <ClosePopUpIcn />
              </button>
            </div>

            <div className="space-y-3 mb-4 grow min-h-0 flex flex-col px-3">
              <div className="h-fit space-y-3">
                <input
                  className={`h-8 pl-2 border rounded-md capitalize bg-white focus:outline-hidden focus:ring-0 block w-full text-sm font-normal ${
                    isDuplicate ? "border-red-500" : "border-[#DFE2E5] focus:border-[#7A7D84]"
                  }`}
                  placeholder="Enter Detail"
                  value={extraFieldData?.field_label}
                  maxLength={25}
                  onChange={(e) => {
                    handleFieldChange("field_label", e);
                    handleCkeckDuplicateList(e.target.value);
                  }}
                />

                {isDuplicate && <p className="text-red-500 text-xs mt-1">{isDuplicate}</p>}

                <div className="flex flex-col font-400 text-sm w-full gap-1">
                  <label className="text-434852 font-poppins text-sm font-normal">Description</label>
                  <textarea
                    className="bg-white border h-20 focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 text-sm font-normal block w-full border-[#DFE2E5] rounded-md placeholder-[rgba(56,56,56,0.40)]"
                    defaultValue={extraFieldData?.field_description}
                    onBlur={(e) => handleFieldChange("field_description", e)}
                    rows="8"
                    placeholder="Type Something..."
                  />
                </div>
              </div>

              <div className="flex flex-col min-h-0 grow">
                <ChoiceField
                  setExtraFieldData={setExtraFieldData}
                  extraFieldData={extraFieldData}
                  setInputValue={setInputValue}
                  inputValue={inputValue}
                  setShadowColor={setShadowColor}
                  shadowColor={shadowColor}
                  setInputVisible={setInputVisible}
                  InputVisible={inputVisible}
                  allowMultiple={allowMultiple}
                  setAllowMultiple={setAllowMultiple}
                  EditFieldData={EditFieldData}
                  setIsEmptyOption={setIsEmptyOption}
                  isEmptyOption={isEmptyOption}
                  // removeChoiceApi={removeChoiceApi}
                  isEditableMode={!!dropDownId}
                  handleFieldOptionUpdate={handleFieldOptionUpdate}
                  handleFieldOptionAdd={handleFieldOptionAdd}
                  isGlobalDropdown
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 pr-2">
              <Button variant={"secondary"} onClick={handleCancelButton} className="p-3">
                Cancel
              </Button>
              <Button variant={"primary"} onClick={handleSave} className="p-3">
                {dropDownId ? "Update" : "Save"}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalListsDropdownTable;
